import { render, staticRenderFns } from "./PropertyMaintenanceItemsPanel.vue?vue&type=template&id=2367fb7d"
import script from "./PropertyMaintenanceItemsPanel.vue?vue&type=script&lang=ts"
export * from "./PropertyMaintenanceItemsPanel.vue?vue&type=script&lang=ts"
import style0 from "./PropertyMaintenanceItemsPanel.vue?vue&type=style&index=0&id=2367fb7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports